export default __webpack_public_path__ + "static/media/Boots of the Renegade.f525ede8.jpg";